export default __webpack_public_path__ + "static/media/acropass-product-details.e7f163ea.jpg";